import React, {useEffect, useMemo, useState} from 'react';
import {useNavigate} from "react-router-dom";
import {CodeSpecNum} from "../../../../../../constant/CodeSpecNum";
import Search from "../../../../../../components/search/Search";
import {DILIGENCE_HEADER} from "../../../../../../components/table/header/Headers";
import SearchSection from "../../../../../../components/search/SearchSection";
import Selector from "../../../../../../components/selector/Selector";
import {searchListener} from "../../../../../../components/commonmethod/simmsDrawerMethod";
import {handleActiveError} from "../../../../../../components/sonner/ToastBasic";
import {deleteDiligence} from "../../../../../../api/asset/DiligenceService";
import {
    getIndividualSetting,
    resetIndividualSetting,
    setIndividualSetting,
} from "../../../../../../api/user/UserAccountService";
import {
    extractObject,
    initHeaderOrders,
    simmsColumnsToJsGridHeaders,
    withListColumnFilters,
} from "../../../../../../components/commonmethod/CommonMethod";
import {ToolbarDataTransfer} from "@bavuchoko/js-grid";
import SimmsJsGrid from "../../../../../../components/js-grid/SimmsJsGrid";
import {navigateWithChildTab, pickDetailTabTitle} from "../../../../../../components/pageTabs/pageTabsStorage";
import {useExcelDownloadClick} from "../../../../../../components/commonmethod/excelMethod";
import JsGridExcelGridOpenButton from "../../../../../../components/js-grid/JsGridExcelGridOpenButton";

function DiligenceListListType({checked, data, date, pageInfo, dataHook}) {
    const navigate = useNavigate();
    const {handleSearch, handlePageSizeChange, saveConditions, refresh, handleGridPageChange} = dataHook;
    const handleDownloadClick = useExcelDownloadClick(saveConditions);

    const listHeader = useMemo(() => withListColumnFilters(DILIGENCE_HEADER), []);
    const [header, setHeader] = useState({order: listHeader, exclude: []});

    const searchDate = {
        startDate: saveConditions.startDate ?? date.startDate,
        endDate: saveConditions.endDate ?? date.endDate,
    };

    useEffect(() => {
        setHeader({order: listHeader, exclude: []});
    }, [listHeader]);

    useEffect(() => {
        getIndividualSetting().then((r) => {
            initHeaderOrders(r, listHeader, setHeader, [], () => {}, () => {}, 'diligence');
        });
    }, [listHeader]);

    const handleRowClick = (row) => {
        const id = row?.id;
        if (id == null) return;
        navigateWithChildTab(navigate, {
            title: pickDetailTabTitle(row, "실사 상세"),
            url: `/diligence/${id}`,
        });
    };

    const deleteDiligenceHandler = async (rows) => {
        if (!rows?.length) {
            alert("삭제할 데이터를 선택하세요");
            return;
        }
        if (!window.confirm("해당 실사와 관련된 정보가 모두 삭제됩니다.\n삭제하시겠습니까?")) {
            return;
        }

        const ids = rows.map((row) => row.id).filter((id) => id != null);
        const response = await deleteDiligence(ids);
        if (response?.status === 200) {
            alert("삭제되었습니다.");
            checked?.setChecked?.([]);
            refresh();
        } else if (response?.status === 201) {
            handleActiveError({message: response.data.title, description: response.data.reason});
        }
    };

    const diligenceJsGridHeader = useMemo(() => simmsColumnsToJsGridHeaders(header), [header]);
    const excelGridSearch = useMemo(() => extractObject(saveConditions), [saveConditions]);

    return (
        <div className="container-height">
            <Search
                entity="diligence"
                refresh={refresh}
                searchConditions={saveConditions}
                handleSearch={handleSearch}
                handlePageSizeChange={handlePageSizeChange}
                pageInfo={pageInfo}
                searchBar={{placeHolder: "실사명"}}
                pin
                size
                detail
                date={searchDate}
            >
                <SearchSection title="기본정보">
                    <Selector
                        showLabel
                        onChange={(value) => searchListener(handleSearch, "code", extractObject(saveConditions), value)}
                        data={saveConditions.code}
                        parentKey={CodeSpecNum.DiligenceCode}
                        render
                        recursive
                        entity="code"
                        title="실사코드"
                    />
                </SearchSection>
            </Search>

            <div className="container-height-body">
                <SimmsJsGrid
                    loading={dataHook.loading}
                    resizable={true}
                    data={data}
                    theme="linear"
                    style={{minHeight: 0, height: "100%"}}
                    header={diligenceJsGridHeader}
                    onHeaderSave={(v) => setIndividualSetting({headers: {diligence: v}})}
                    onHeaderReset={() => resetIndividualSetting("headers", "diligence")}
                    enableRowSelection={true}
                    onRowClick={handleRowClick}
                    onPageChange={handleGridPageChange}
                    toolbarEnd={() => (
                        <div className="flex items-center gap-2">
                            <JsGridExcelGridOpenButton entityName="Diligence" search={excelGridSearch} />
                            <ToolbarDataTransfer
                                hint="선택 항목 삭제"
                                busyHint="삭제 중…"
                                overlayLabel="삭제 중…"
                                onTransfer={deleteDiligenceHandler}
                            >
                                {(ctx) => (
                                    <button
                                        type="button"
                                        className="text-[13px] px-3 py-0.5 text-black rounded-4 border disabled:cursor-not-allowed"
                                        disabled={ctx.disabled}
                                        onClick={() => void ctx.transferSelected()}
                                    >
                                        삭제
                                    </button>
                                )}
                            </ToolbarDataTransfer>
                            <button
                                type="button"
                                className="text-[13px] px-3 py-0.5 border text-white bg-themeDark rounded-4"
                                onClick={() => navigate("/diligence/create")}
                            >
                                등록
                            </button>
                        </div>
                    )}
                />
            </div>
        </div>
    );
}

export default DiligenceListListType;
